import { DateRangePicker } from "@mantine/dates";
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import { getColors } from "./constants";
import { CalendarIcon } from "./icons";
import { createGetDayStyle } from "./dayStyle";
import { buildCalendarStyles } from "./calendarStyles";
import MonthAwareRangePicker from "./MonthAwareRangePicker";

const DateRangeInput = ({
  placeholder,
  value,
  onChange,
  tooltip,
  classNames = "",
  inputFormat,
  highlightToday = false,
  dayStyle,
  enableMonthRange = false,
}) => {
  const { isDark } = useStoreState(Store, (s) => ({
    isDark: s.isDarkMode,
  }));

  value = value?.map((item) => {
    if (typeof item === "string") {
      return new Date(item);
    }
    return item;
  });

  const colors = getColors(isDark);
  const getDayStyle = createGetDayStyle({ highlightToday, dayStyle, isDark });

  // --- Month-range enabled picker -----------------------------------------
  if (enableMonthRange) {
    return (
      <MonthAwareRangePicker
        value={value}
        onChange={onChange}
        tooltip={tooltip}
        placeholder={placeholder}
        classNames={classNames}
        isDark={isDark}
        getDayStyle={getDayStyle}
      />
    );
  }

  // --- Default (day-only) behaviour ---------------------------------------
  const inputStyle = {
    input: {
      fontSize: "12px",
      color: colors.text,
      border: `1px solid ${colors.border}`,
      borderRadius: "6px",
      backgroundColor: colors.bg,
      "&:focus-within": { borderColor: colors.border },
      // Dark mode keeps the placeholder bright (text colour); light mode
      // dims it to the muted sub-text colour.
      "::placeholder": { color: isDark ? colors.text : colors.subText },
    },
  };

  return (
    <div
      title={tooltip}
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={classNames}
    >
      <DateRangePicker
        allowSingleDateInRange={true}
        inputFormat={inputFormat}
        icon={<CalendarIcon isDark={isDark} />}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        dayStyle={getDayStyle}
        withinPortal={true}
        styles={{
          root: {
            position: "relative",
          },
          wrapper: {},
          icon: {},
          dropdown: {
            backgroundColor: colors.bg,
            border: `1px solid ${colors.border}`,
            transition: "none !important",
            marginTop: "-5px",
            display: "flex",
            justifyContent: "center",
            position: "fixed",
            zIndex: "1000 !important",
          },
          ...buildCalendarStyles(colors),
          ...inputStyle,
        }}
      />
    </div>
  );
};

export default DateRangeInput;
